<template>
  <v-content class="shop" v-if="shop">
    <v-img v-if="shop.image_path" :src="shop.image_path" lazy-src="@/assets/noimg@2x.png" class="mb-4">
          <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
  </v-row>
        </template>
    </v-img>
    <v-img v-else src="@/assets/noimg@2x.png" lazy-src="@/assets/noimg@2x.png" class="mb-4">
    </v-img>

  <div class="mb-3 px-2 followbtnwrap">

      <div class="followbtn">
        <transition enter-active-class="animate__animated animate__bounceIn">
        <img src="@/assets/info/btn_follow_on.svg" v-show="shop.is_follow" @click="followSet(0, shop.id)">
        </transition>
        <transition enter-active-class="animate__animated animate__bounceIn">
        <img src="@/assets/info/btn_follow.svg" v-show="!shop.is_follow" @click="followSet(1, shop.id)">
        </transition>
      </div>

  </div>

    <h1 class="title font-weight-bold text-center mb-1">{{shop.name.value}}</h1>
    <p class="fontsize11 text-center mb-12" style="color:#9D9D9D;">{{shop.name_kana}}</p>

    <h2 class="subtitle-1 font-weight-bold text-center mb-3">{{shop.catch_copy}}</h2>
    <p class="fontsize11 mb-12 px-3">{{shop.description}}</p>

    <div class="shop_details">
    <!-- 20201214 NEW_DEV-734 A28 NO.19,NO.22,NO.23 cyber 段 start -->
    <v-row no-gutters align="center" class="pa-3" v-if="shop.address1.value">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.address1.name}}</v-col>
      <v-col cols="8" class="nl2br maincolor fontsize13 font-weight-bold" @click="toMap()">{{shop.address1.value}} {{shop.address2.value}}</v-col>
      <v-col cols="1">
          <svg class="svg_maincolor" @click="toMap()"
          xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 32 32"><g transform="translate(-319 -1125)"><g transform="translate(319 1125)" fill="none" stroke="#ff00b1" stroke-width="1"><circle cx="15" cy="15" r="15" stroke="none"/><circle cx="15" cy="15" r="14.5" fill="none"/></g><g transform="translate(315.117 1132)"><path d="M18.773,0a5.9,5.9,0,0,0-5.89,5.891A5.746,5.746,0,0,0,13.4,8.3a37.14,37.14,0,0,0,5.127,7.591.328.328,0,0,0,.5,0A37.159,37.159,0,0,0,24.149,8.3a5.743,5.743,0,0,0,.515-2.4A5.9,5.9,0,0,0,18.773,0Zm0,8.95a3.06,3.06,0,1,1,3.06-3.06A3.063,3.063,0,0,1,18.773,8.95Z" transform="translate(0)" fill="#ff00b1"/></g></g></svg>
      </v-col>
    </v-row>
    <v-row no-gutters align="center" class="pa-3" v-if="shop.tel.value">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.tel.name}}</v-col>
      <v-col cols="8" class="nl2br maincolor fontsize13 font-weight-bold"><a class="maincolor" style="text-decoration:none;" :href="'tel:'+shop.tel.value">{{shop.tel.value}}</a></v-col>
      <v-col cols="1">
        <a :href="'tel:'+shop.tel.value">
          <svg class="svg_maincolor" xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 32 32"><g transform="translate(-329 -715)"><g transform="translate(337 722.812)"><g transform="translate(0 0.188)"><path d="M13.993,11.23a.677.677,0,0,1-.207.593l-1.971,1.956a1.109,1.109,0,0,1-.348.252,1.439,1.439,0,0,1-.422.133l-.089.007q-.074.007-.193.007a6.832,6.832,0,0,1-.912-.1,6.922,6.922,0,0,1-1.541-.474,12.938,12.938,0,0,1-2.068-1.134A15.415,15.415,0,0,1,3.782,10.4,16.241,16.241,0,0,1,2.063,8.443a13.939,13.939,0,0,1-1.1-1.727A9.3,9.3,0,0,1,.343,5.279,7.627,7.627,0,0,1,.062,4.167,3.671,3.671,0,0,1,0,3.434q.015-.267.015-.3a1.441,1.441,0,0,1,.133-.422A1.111,1.111,0,0,1,.4,2.367L2.374.4A.653.653,0,0,1,2.848.188.553.553,0,0,1,3.189.3a1.03,1.03,0,0,1,.252.274L5.027,3.582A.721.721,0,0,1,5.1,4.1a.924.924,0,0,1-.252.474L4.123,5.3a.247.247,0,0,0-.052.1.366.366,0,0,0-.022.111,2.676,2.676,0,0,0,.267.711,6.53,6.53,0,0,0,.548.867A9.627,9.627,0,0,0,5.916,8.265,9.817,9.817,0,0,0,7.1,9.325a6.847,6.847,0,0,0,.867.556A2.3,2.3,0,0,0,8.5,10.1l.185.037a.353.353,0,0,0,.1-.022.247.247,0,0,0,.1-.052l.845-.86a.908.908,0,0,1,.622-.237.774.774,0,0,1,.4.089h.015l2.86,1.69A.746.746,0,0,1,13.993,11.23Z" transform="translate(0 -0.188)" fill="#ff00b1"/></g></g><g transform="translate(329 715)" fill="none" stroke="#ff00b1" stroke-width="1"><circle cx="15" cy="15" r="15" stroke="none"/><circle cx="15" cy="15" r="14.5" fill="none"/></g></g></svg>
        </a>
      </v-col>
    </v-row>
    <v-row no-gutters align="center" class="pa-3" v-if="shop.opening_hours.value">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.opening_hours.name}}</v-col>
      <v-col cols="9" class="nl2br maincolor fontsize13 font-weight-bold">{{shop.opening_hours.value}}</v-col>
    </v-row>
    <v-row no-gutters align="center" class="pa-3" v-if="shop.holiday.value">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.holiday.name}}</v-col>
      <v-col cols="9" class="nl2br maincolor fontsize13 font-weight-bold">{{shop.holiday.value}}</v-col>
    </v-row>
    <v-row no-gutters align="center" class="pa-3" v-if="shop.seats_number.value">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.seats_number.name}}</v-col>
      <v-col cols="9" class="nl2br maincolor fontsize13 font-weight-bold">{{shop.seats_number.value}}</v-col>
    </v-row>
    <v-row no-gutters align="center" class="pa-3" v-if="shop.parking.value">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.parking.name}}</v-col>
      <v-col cols="9" class="nl2br maincolor fontsize13 font-weight-bold">{{shop.parking.value}}</v-col>
    </v-row>
    <v-row no-gutters align="center" class="pa-3" v-if="shop.price.value">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.price.name}}</v-col>
      <v-col cols="9" class="nl2br maincolor fontsize13 font-weight-bold">{{shop.price.value}}</v-col>
    </v-row>
    <v-row no-gutters align="center" class="pa-3" v-if="shop.other.value">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.other.name}}</v-col>
      <v-col cols="9" class="nl2br maincolor fontsize13 font-weight-bold">{{shop.other.value}}</v-col>
    </v-row>

    <v-row no-gutters align="center" class="pa-3" v-if="shop.reserve_url">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.reserve.name}}</v-col>
      <v-col cols="8" class="nl2br maincolor fontsize13 font-weight-bold" @click.stop="toReserveHref(shop.reserve_url)">{{shop.reserve_url}}</v-col>
      <v-col cols="1" @click.stop="toReserveHref(shop.reserve_url)">
          <svg class="svg_maincolor" xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 32 32"><g transform="translate(-329 -755)"><g transform="translate(329 755)" fill="none" stroke="#ff00b1" stroke-width="1"><circle cx="15" cy="15" r="15" stroke="none"/><circle cx="15" cy="15" r="14.5" fill="none"/></g><g transform="translate(277 761)"><path d="M3.75,11.857a.536.536,0,1,1,0-1.071H5.393V9.715H1.607A1.609,1.609,0,0,1,0,8.107V7.572H14v.536a1.609,1.609,0,0,1-1.607,1.607H8.607v1.071H10.25a.536.536,0,1,1,0,1.071ZM0,6.5V1.607A1.609,1.609,0,0,1,1.607,0H12.393A1.609,1.609,0,0,1,14,1.607V6.5Z" transform="translate(60 3)" fill="#ff00b1"/></g></g></svg>
      </v-col>
    </v-row>

    <div v-if="shop.links">
    <v-row no-gutters align="center" class="pa-3" v-for="(link, index) in shop.links" :key="index">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{link.link_comment}}</v-col>
      <v-col cols="8" class="nl2br maincolor fontsize13 font-weight-bold" @click.stop="toHref(link.link_path)">{{link.link_path}}</v-col>
      <v-col cols="1" @click.stop="toHref(link.link_path)">
          <svg class="svg_maincolor" xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 32 32"><g transform="translate(-329 -755)"><g transform="translate(329 755)" fill="none" stroke="#ff00b1" stroke-width="1"><circle cx="15" cy="15" r="15" stroke="none"/><circle cx="15" cy="15" r="14.5" fill="none"/></g><g transform="translate(277 761)"><path d="M3.75,11.857a.536.536,0,1,1,0-1.071H5.393V9.715H1.607A1.609,1.609,0,0,1,0,8.107V7.572H14v.536a1.609,1.609,0,0,1-1.607,1.607H8.607v1.071H10.25a.536.536,0,1,1,0,1.071ZM0,6.5V1.607A1.609,1.609,0,0,1,1.607,0H12.393A1.609,1.609,0,0,1,14,1.607V6.5Z" transform="translate(60 3)" fill="#ff00b1"/></g></g></svg>
      </v-col>
    </v-row>
    </div>

    <v-row no-gutters align="center" class="pa-3" v-if="shop.email.value">
      <v-col cols="3" class="fontsize11" style="color:#9D9D9D;">{{shop.email.name}}</v-col>
      <v-col cols="8" class="nl2br maincolor fontsize13 font-weight-bold"><a class="maincolor" style="text-decoration:none;" :href="'mailto:'+shop.email.value">{{shop.email.value}}</a></v-col>
      <v-col cols="1">
        <a :href="'mailto:'+shop.email.value">
          <svg class="svg_maincolor" xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 32 32"><g transform="translate(-319 -1125)"><g transform="translate(319 1125)" fill="none" stroke="#ff00b1" stroke-width="1"><circle cx="15" cy="15" r="15" stroke="none"/><circle cx="15" cy="15" r="14.5" fill="none"/></g><g transform="translate(327 1080.18)"><g transform="translate(0 54.82)"><path d="M1.344,58.211q.266.187,1.6,1.113T4.992,60.75l.332.238q.254.184.422.3t.406.254a2.357,2.357,0,0,0,.449.211,1.238,1.238,0,0,0,.391.07h.016a1.239,1.239,0,0,0,.391-.07,2.359,2.359,0,0,0,.449-.211q.238-.141.406-.254t.422-.3q.254-.184.332-.238l3.656-2.539a3.711,3.711,0,0,0,.953-.961A2.063,2.063,0,0,0,14,56.07a1.261,1.261,0,0,0-1.25-1.25H1.25a1.116,1.116,0,0,0-.926.406A1.577,1.577,0,0,0,0,56.242a1.825,1.825,0,0,0,.43,1.066A3.878,3.878,0,0,0,1.344,58.211Z" transform="translate(0 -54.82)" fill="#ff00b1"/><path d="M13.219,185.117q-2.562,1.734-3.89,2.7-.445.328-.723.512a4.461,4.461,0,0,1-.738.375,2.248,2.248,0,0,1-.859.191H6.992a2.249,2.249,0,0,1-.859-.191,4.463,4.463,0,0,1-.738-.375q-.277-.183-.723-.512-1.055-.773-3.883-2.7a4.138,4.138,0,0,1-.789-.68v6.2a1.2,1.2,0,0,0,.367.883,1.2,1.2,0,0,0,.883.367h11.5A1.254,1.254,0,0,0,14,190.64v-6.2A4.308,4.308,0,0,1,13.219,185.117Z" transform="translate(0 -180.89)" fill="#ff00b1"/></g></g></g></svg>
        </a>
        </v-col>
    </v-row>
    </div>
    <!-- 20201214 NEW_DEV-734 A28 NO.19,NO.22,NO.23 cyber 段 end -->
    <div v-if="shop.fb_link_path || shop.twitter_link_path || shop.instragram_link_path">
      <v-divider class="px-3 my-3"></v-divider>

      <h2 class="text-center body-2 font-weight-bold mb-2">SNS</h2>
      <div class="px-3">
      <v-row dense align="center" justify="center" class="mb-10">
        <v-col cols="4" v-if="shop.fb_link_path">
          <v-btn small class="px-2 w100 maincolor" rounded outlined @click.stop="toHref(shop.fb_link_path)">facebook <v-icon x-small right class="ml-1 maincolor">fab fa-facebook-f</v-icon></v-btn>
        </v-col>
        <v-col cols="4" v-if="shop.twitter_link_path">
          <v-btn small class="px-2 w100 maincolor" rounded outlined @click.stop="toHref(shop.twitter_link_path)">X(旧Twitter) 
            <!--<v-icon x-small right class="ml-1 maincolor">fab fa-twitter</v-icon>-->
            <svg class="svg_maincolor" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg" width="10" height="10">
               <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
            </svg>
          </v-btn>
        </v-col>
        <v-col cols="4" v-if="shop.instragram_link_path">
          <v-btn small class="px-2 w100 maincolor" rounded outlined @click.stop="toHref(shop.instragram_link_path)">instagram <v-icon x-small right class="ml-1 maincolor">fab fa-instagram-square</v-icon></v-btn>
        </v-col>
      </v-row>
      </div>
    </div>

    <v-overlay :value="loading" z-index=9999>
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      maincolor: this.$root.maincolor,
      shop: null,
      loading: false,
    }
  },
  async created() {
    this.getUrlParam()
    this.init = this.storageGet('*')

    var req = { params:{
      'shop_id': this.init.shop_id,
      'preview':  this.getUrlGetParam('preview')
    }}

    try {
      var res = await this.apiCall('/user/shop/detail', req)

      this.$set(this, 'shop', res.shop)
      if (!res) return false;
    } catch(e) {
      this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
    }
  },
  methods: {
    toHref(url) {
      var req = {
        destination: url,
        transition_type: 4,
      }
      if (!(this.screenTransition(req))) {
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }
    },
    async toReserveHref(url) {
      try {
        // 単店の場合は本ページ呼び出し時にshop_idのパラメータが付かないため、sidの値で代用する必要がある
        var shop_id = this.init.shop_id
        if (shop_id === null || shop_id === undefined) {
            shop_id = this.init.sid
        }
        var reservecount_req = {
          'sid': this.init.sid,
          'user_id': this.init.user_id,
          'shop_id': shop_id,
        }

        var reservecount_res = await this.apiCall('/user/shop/countreserve', reservecount_req, 'post')

        if (!reservecount_res) return false;
      } catch(e) {
        this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
      }

      var req = {
        destination: url,
        transition_type: 4,
      }
      if (!(this.screenTransition(req))) {
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }
    },
    toMap() {
      var req = {
          destination: 'https://' + process.env.VUE_APP_HOST_NAME + "/sp/info/map?shop_id" + this.init.shop_id,
          feature_id: "shopinfo",
          screen_id: "shopinfo",
          transition_type: 2,
          page_title: "店舗マップ",
      }
      if (!(this.screenTransition(req))) {
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }
    },
    async followSet(flg, shop_id){
      try {
        // 多重処理防止
        if (this.loading) return
        this.loading = true

        if(flg == 0){
          this.shop.is_follow = false
        }else{
          this.shop.is_follow = true
        }
        /* 店舗フォローAPIを叩く */
        var req = {
          'shop_id': shop_id,
          'flg': flg,
        }
        var follow_res = await this.apiCall('/user/favorite', req, 'post');
        if (!follow_res) { return false }

      } catch(e) {
        this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
      } finally {
        // 正常, 異常に関わらず処理完了時はスピナー解除
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>
.followbtnwrap {
  position: relative;
  height: 23px;
}
.followbtn {
  position: absolute;
  top:0;
  right: 10px;
  overflow: hidden;
  width: 89px;
  height: 23px;
}
.followbtn img {
  position: absolute;
}
.shop_details {
  line-height: 16px;
}
</style>
